import {GetRefundCitiesParams} from 'domain/usecases';
import {makeGetRefundCities} from 'main/factories/usecases';

export const getRefundCities = async (params: GetRefundCitiesParams) => {
	const data = await makeGetRefundCities().get(params);

	return data.content.cities;
};
